import { Button } from '@frontend/ui';

export function HomePage() {
  return (
    <main className="mx-auto flex min-h-screen max-w-3xl flex-col items-start gap-6 p-8">
      <header className="space-y-2">
        <h1 className="text-h3">Advisor Platform — Phase 1 skeleton</h1>
        <p className="text-text-secondary">End-to-end Signal token + design system smoke test.</p>
      </header>

      <section className="flex flex-wrap gap-2">
        <Button>Contained</Button>
        <Button variant="outlined">Outlined</Button>
        <Button variant="text">Text</Button>
      </section>

      <section className="grid w-full grid-cols-2 gap-3 sm:grid-cols-4">
        <div className="border-border-primary bg-surface-primary rounded-md border p-3 shadow-sm">
          <div className="h-6 rounded-sm bg-neutral-700" />
          <p className="text-text-secondary mt-2 text-xs">neutral-700 (ink)</p>
        </div>
        <div className="border-border-primary bg-surface-primary rounded-md border p-3 shadow-sm">
          <div className="bg-primary-900 h-6 rounded-sm" />
          <p className="text-text-secondary mt-2 text-xs">primary-900 (action)</p>
        </div>
        <div className="border-border-primary bg-surface-primary rounded-md border p-3 shadow-sm">
          <div className="bg-success-700 h-6 rounded-sm" />
          <p className="text-text-secondary mt-2 text-xs">success-700</p>
        </div>
        <div className="border-border-primary bg-surface-primary rounded-md border p-3 shadow-sm">
          <div className="bg-danger-700 h-6 rounded-sm" />
          <p className="text-text-secondary mt-2 text-xs">danger-700</p>
        </div>
      </section>
    </main>
  );
}
